// The texts of the "Novosti in izboljšave" page (/novosti). Edit here; the page shows them as they are.
//
// A row: { title, sub, right } - `right` is what stands on the right of the row:
//   { type: "text", text }                        plain text (e.g. Brezplačno)
//   { type: "link", text, href }                  blue underlined link
//   { type: "popup", text, popup }                text with a red "?" that opens a popup ("promo", "local")
//   { type: "order", text, product }              text with a red "?" that opens the order popup of that product
//   { type: "box", title, lines | bullets }       grey information box (hidden on phones)
//   { type: "symbols" }                           the religious symbols
//   { type: "help", popup | order }              only a red "?"
// `titleHelp` puts a red "?" after the title (popup / order as above). `phoneHelp` shows a "?" on phones only.
// `phone: { title, sub, right }` replaces those texts on phones (up to 742px) - the phone design has its own wording;
// `phone.right: null` shows nothing on the right. A section can have `phoneTitle`.

// The memory page the "Primer: ..." link shows as an example.
export const EXAMPLE_PAGE_HREF = "/m/Mario_Danilo_Primo_311225";

export const NOVOSTI_DATE = "Oktober '26";

export const SECTIONS = [
  {
    title: "Žalna stran",
    tone: "navy",
    rows: [
      {
        title: "Žalna knjiga in Sožalja (izbira)",
        sub: "Vpis je zdaj brez prijave v račun.",
        right: { type: "text", text: "Brezplačno" },
      },
      {
        title: "Nadgradnja za fotografije",
        sub: "Objavo potrdi skrbnik spominske strani.",
        right: { type: "text", text: "Brezplačno" },
        phone: { sub: "Objavo odobri skrbnik." },
      },
      {
        title: "Novost: Spominska svečka",
        sub: "Lahko je tudi darilo.",
        exampleLink: "Primer: Mario stran",
        phone: { right: { type: "link", text: "Primer: Mario stran", href: EXAMPLE_PAGE_HREF } },
        right: {
          type: "box",
          title: "Dvojna korist",
          lines: [
            "Spominska svečka je hkrati tudi darilo. Poleg svečke in vpisa, podarite obstoječemu skrbniku spominske strani hkrati tudi podaljšanje njegovega statusa skrbnika za enako število let.",
          ],
        },
      },
      {
        title: "Olajšano pošiljanje digitalnih kartic",
        sub: "Izbereš kartico > vneseš številko > pošlješ",
        right: { type: "text", text: "Brezplačno" },
        phone: { title: "Olajšano pošiljanje mobi kartic" },
      },
    ],
  },
  {
    title: "Skrbnik | Spominska stran",
    phoneTitle: "Skrbnik",
    tone: "red",
    rows: [
      { title: "Brezplačni skrbnik za 10 dni", sub: "Dovolj časa za izdelavo prave spominske strani.", right: { type: "text", text: "Brezplačno" } },
      {
        title: "Omogočeni so religiozni simboli",
        sub: "Doda jih lahko Skrbnik",
        right: { type: "symbols" },
        phone: { sub: "Doda jih lahko skrbnik.", right: { type: "symbols", extraText: "Brezplačno" } },
      },
      {
        title: "Novost: Zasebna spominska stran",
        sub: "Preko gesla, samo za bližnje.",
        right: { type: "text", text: "Vključeno v letnega Skrbnika" },
        phone: { title: "Novost: Zasebna stran", right: { type: "text", text: "Brezplačno" } },
      },
      {
        title: "Novost: Spominska za davno pokojne",
        sub: "Podvojena doba do 15. novembra.",
        right: { type: "popup", text: "Aktualna promocija", popup: "promo" },
        phone: { title: "Spominska za davno pokojne", sub: "Do 15. novembra dvojna doba." },
      },
    ],
  },
  {
    title: "Druge izboljšave",
    tone: "purple",
    rows: [
      { title: "Izboljšan pregled osmrtnic", sub: "Lažje iskanje po imenu, hitrejše." },
      { title: "Posebna stran za zahvale, spomine", sub: "obletnice, posvetila, zadnji klic. Za topel poklon." },
      {
        title: "Lokalne informacije z enim klikom",
        sub: "Končno deluje, kot treba.",
        phoneHelp: { popup: "local" },
        right: {
          type: "box",
          title: "1 klik do vedno osveženih podatkov",
          bullets: [
            "pri prijavi določite svojo občino",
            "vsakič kasneje lahko z enim klikom na lokacijsko ikonico na vrhu strani, brez iskanja občine, najdete nove osmrtnice in pogrebe.",
          ],
        },
      },
      { title: "Omogočeno naročanje", sub: "Možnost plačevanja s kartico" },
      {
        title: "Izboljšave v uporabniškem računu",
        sub: "Enostavno sledenje bližnjim in dodane funkcije",
        phone: { sub: "Enostavno sledenje in dodane funkcije" },
      },
      {
        title: "Prejemanje obvestil",
        sub: "Opomniki pred obletnicami vaših bližnjih in drugo",
        phone: { sub: "Pred obletnicami bližnjih in druga" },
      },
      { title: "Lažja prijava in registracija", sub: "Omogočena tudi Google prijava" },
      {
        title: "Poudarjena osmrtnica",
        sub: "Izstopa in do pogreba je vedno na zgornjem mestu",
        titleHelp: { order: "highlight" },
        phone: { sub: "Izstopa in je na najbolj vidnem mestu", titleHelp: null, right: { type: "help", order: "highlight" } },
      },
    ],
  },
  {
    title: "Oglaševalci",
    tone: "green",
    rows: [
      { title: "Približanje potrebam oglaševalcev", sub: "Dostopnejši cenik in povezane informacije", right: { type: "link", text: "Glej cenik", href: "/cenik" } },
      { title: "Možnost kampanj po meri", sub: "Morda tudi možnost kakšne ekskluzive", right: { type: "link", text: "Kontaktirajte nas", href: "/kontakt" } },
      {
        title: "Več kot 30.000 obiskovalcev mesečno",
        sub: "in dodatno preko petih strani lokalnih novic",
        right: { type: "text", text: "Cilj je 50.000 v januarju" },
      },
      {
        title: "Podvojeno oglaševanje za isto ceno",
        sub: "Promocija traja do 15. novembra",
        right: { type: "popup", text: "Zdaj je priložnost", popup: "ads" },
        phone: { right: { type: "text", text: "Zdaj je priložnost" } },
      },
    ],
  },
];

// The slider at the bottom ("Prvo leto je za nami"): five slides, in this order. `phoneLines` replaces `lines` on
// phones when the phone design words it differently. The last slide is the closing message (no number).
export const FOOTER_TITLE = "Prvo leto je za nami";
export const FOOTER_SLIDES = [
  { big: "207", lines: ["Število občin z zabeleženimi vpisi.", "Vse regije, brez belih lis."] },
  { big: "11.573", lines: ["obiskov na najbolj obiskani spominski strani", "Največ prižganih svečk na eni strani: 401"] },
  {
    big: "5",
    lines: ["Lokalnih novic, ki objavljajo naše osmrtnice", "Skupno imajo več kot pol milijona obiskovalcev mesečno"],
  },
  { big: "30.000+", lines: ["Obiskovalcev mesečno.", "Cilj v januarju je 50.000."] },
  {
    closing: true,
    paragraphs: [
      ["Največ objav in ažurno dodajanje."],
      ["Največ načinov, da svojci in prijatelji sodelujejo pri ohranjanju spomina.", "Največ brezplačnih možnosti in najnižja cena spominske strani."],
    ],
    headline: "Drugo leto je vedno boljše",
    thanks: "Hvala, ker ste bili z nami v prvem letu.",
  },
];

// Popups opened by a red "?".
export const POPUPS = {
  promo: {
    title: "Bližnji, ki so odšli pred letom 2026",
    paragraphs: ["Za bližnje, ki so se poslovili pred letom 2026, prejme naročnik spominske dvakratno dobo."],
    bullets: ["Spominska stran za 2 leti - 20€", "Spominska stran za 10 let - 30€"],
    after: ["Promocija traja do vključno 15.11."],
    order: { text: "Ustvari spominsko stran", product: "past" },
  },
  ads: {
    title: "Podvojeno oglaševanje za isto ceno",
    paragraphs: ["Podvojeno oglaševanje za isto ceno, Promocija traja do 15.novembra.", "Za več informacij nas kontaktirajte."],
    link: { text: "Kontaktirajte nas", href: "/kontakt" },
  },
  local: {
    title: "Lokalne informacije brez iskanja",
    bullets: [
      "pri prijavi določite svojo občino",
      "vsakič kasneje lahko z enim klikom na lokacijsko ikonico na vrhu strani, brez iskanja občine, najdete nove osmrtnice in pogrebe.",
    ],
  },
};
